<template>
  <div>
    <div class="text-center" v-if="!dataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mt-1" v-show="dataLoaded">
      <v-row>
        <v-col cols="12" class="d-flex align-end justify-space-between">
          <v-btn
            small
            outlined
            color="primary"
            class="white--text px-4"
            @click="dialog = true"
          >
            <v-icon left small>mdi-plus</v-icon>Добавить
          </v-btn>
        </v-col>
      </v-row>

      <PageTable
        :table-loading="tableLoading"
        :table-headers="tableHeaders"
        :table-items="departments.list"
      >
        <template v-slot:item.actions="{ item }">
          <v-icon color="lightGrey" class="mr-2 eye-btn" size="22" title="Просмотр" @click="show(item)">
            mdi-eye-outline
          </v-icon>
          <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">
            mdi-pencil-outline
          </v-icon>
          <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
            mdi-trash-can-outline
          </v-icon>
        </template>
      </PageTable>
    </div>

    <DepartmentDialog
      :dialog="dialog"
      :saveBtnLoading="btnLoading"
      :selectedItem="selectedItem"
      :isShowMode="isShowMode"
      @saveDepartment="saveDepartment"
      @closeModal="closeDialog"
    />

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeDepartment"
      @closeModal="closeDialog"
    />
  </div>
</template>

<script>
import { departmentApi } from '@/api'
import { Departments } from '@/models'
import PageTable from '@/components/ui/Table'
import DepartmentDialog from '@/components/zvp/dictionaries/department/dialogs/Department'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'

export default {
  name: 'Department',

  components: {
    PageTable,
    DepartmentDialog,
    ConfirmDialog
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.getGroups()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'Факультет', value: 'name', sortable: false, align: 'start' },
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '130px' }
    ],
    departments: new Departments(),
    dataLoaded: false,
    tableLoading: false,
    selectedItem: null,
    isShowMode: false,
    dialog: false,
    confirmDialog: false,
    btnLoading: false
  }),

  methods: {
    async getGroups() {
      const data = await departmentApi.getCatalog()
      if(data) data.forEach(obj => this.departments.addDepartment(obj))
    },

    async saveDepartment(body) {
      try {
        this.btnLoading = true

        const data = body.id
          ? await departmentApi.updateDepartment(body)
          : await departmentApi.createDepartment(body)

        body.id ? this.departments.updateDepartment(data) : this.departments.addDepartment(data)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.btnLoading = false
      }
    },

    async removeDepartment() {
      try {
        this.btnLoading = true

        await departmentApi.removeDepartment(this.selectedItem.id)
        this.departments.removeDepartment(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.btnLoading = false
      }
    },

    show(item) {
      this.selectedItem = item
      this.dialog = true
      this.isShowMode = true
    },

    edit(item) {
      this.selectedItem = item
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item
      this.confirmDialog = true
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
      this.isShowMode = false
    },
  },
}
</script>

<style scoped>
</style>
